export enum FieldStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  DELETED = 'deleted',
}

export enum FieldType {
  ARRAY = 'array',
  COLLECTION = 'collection',
  BOOLEAN = 'boolean',
  DATE = 'date',
  DATETIME = 'datetime',
  ENUM = 'enum',
  NUMBER = 'number',
  SET = 'set',
  TEXT = 'text',
  TAG = 'tag',
  // SYSTEM
  SYSTEM_BOOLEAN = 'system_boolean',
  SYSTEM_TEXT = 'system_text',
  SYSTEM_TAG = 'system_tag',
  SYSTEM_NUMBER = 'system_number',
  SYSTEM_DATE = 'system_date',
  SYSTEM_DATETIME = 'system_datetime',
  SYSTEM_SWITCH = 'system_switch',
  SYSTEM_CURRENT_DATETIME = 'system_current_datetime',
  SYSTEM_ENUM = 'system_enum',
}

export enum FieldGroupId {
  RECOMMENDED = 'recommended',
  USER = 'cuf',
  BOT = 'gaf',
  SYSTEM = 'suf',
  STATIC = 'static',
  INTEGRATION = 'integration',
  CONTEXT = 'lcf',
  FORMAT_DATE = 'format_date',
  TAG = 'tag',
  AI = 'ai',
}

export enum FieldSegmentType {
  CUF = 'cuf',
  GAF = 'gaf',
  SUF = 'suf',
  LCF = 'lcf',
  INTEGRATION_USER_FIELD = 'integration_user_field',

  SYSTEM_GENDER = 'gender',
  SYSTEM_SUBSCRIBED = 'subscribed',

  TAG = 'tag',
  SEQUENCE = 'sequence',
  WIDGET = 'widget',
  SMART_SEGMENT = 'smart_segment',
  ADS_GROWTH_TOOL = 'ads_growth_tool',

  ONE_TIME_NOTIFICATION = 'one_time_notification',
  ONE_TIME_NOTIFICATION_OPTIN = 'one_time_notification_optin',
  IG_RECURRING_NOTIFICATION = 'ig_recurring_notification',
  IG_RECURRING_NOTIFICATION_OPTIN = 'ig_recurring_notification_optin',

  CUSTOM_EVENT = 'custom_event',
  OPTED_IN_THROUGH_API = 'opt_in_through_api',
  CONVERSATION_CHANNEL = 'conversation_channel',

  CONTENT_CLICKED = 'content:clicked',
  CONTENT_READ = 'content:read',
  CONTENT_DELIVERED = 'content:delivered',
  CONTENT_SENT = 'content:sent',
  CONTENT_BOUNCED = 'content:bounced',
  CONTENT_SPAM_REPORT = 'content:spamreport',
  CONTENT_UNSUBSCRIBED = 'content:unsubscribed',
  CONTENT_HELD = 'content:held',
  CONTENT_BUTTON_CLICKED = 'button:clicked',

  THREAD_ASSIGNED = 'thread:assigned',
  THREAD_MENTIONED = 'thread:mentioned',
  THREAD_STATUS = 'thread:status',

  SYSTEM_CURRENT_DATETIME = 'system_current_datetime',

  REMOTE_APP = 'app',

  IG_ONBOARDING = 'ig_onboarding',

  AI_AUTOMATION_SESSION = 'ai_automation_session',
}
